import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'lib/react-markdown';
const createElement = React.createElement;
import * as styles from 'styles/index.scss';

const { markDownContainer } = styles;

function getCoreProps(props) {
  return props['data-sourcepos'] ? { 'data-sourcepos': props['data-sourcepos'] } : {};
}

function Heading({ node, level, ...props }) {
  const adjustedLevel = Math.max(2, level);
  return createElement(`h${adjustedLevel}`, getCoreProps(props), props.children);
}

const customRenderers = {
  a: ({ node, href, children, ...props }) => {
    return (
      <a rel="nofollow" target="_blank" href={href} {...props}>
        {children}
      </a>
    );
  },
  h1: props => <Heading level={1} {...props} />,
  h2: props => <Heading level={2} {...props} />,
  h3: props => <Heading level={3} {...props} />,
  h4: props => <Heading level={4} {...props} />,
  h5: props => <Heading level={5} {...props} />,
  h6: props => <Heading level={6} {...props} />
};

function generateTextChunks(currentString) {
  let newString = '';
  const chunks = [];

  iterateOverStringCharsCode(currentString, (charCode, idx) => {
    if (charCode === 10) {
      chunks.push(newString);
      newString = '';
    } else {
      newString += currentString.charAt(idx);
    }
  });

  chunks.push(newString);
  const filteredChunks = chunks.filter(c => c.length > 0);
  return filteredChunks;
}

class Markdown extends PureComponent {
  render() {
    let markdown = this.props.data && this.props.data.markdown ? this.props.data.markdown : null;
    markdown = !markdown && this.props.source ? this.props.source : markdown;
    const className = this.props.className ? this.props.className : '';
    return (
      <ReactMarkdown components={customRenderers} className={className} {...this.props}>
        {markdown}
      </ReactMarkdown>
    );
  }
}

Markdown.propTypes = {
  data: PropTypes.shape({
    markdown: PropTypes.string.isRequired
  }).isRequired
};

export default Markdown;
